import { Component, EventEmitter } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IconComponent } from '../icon/icon.component';

@Component({
  selector: 'ly-confirm-popover',
  standalone: true,
  imports: [CommonModule, IconComponent],
  template: `
    <div class="confirm-popover">
      <div class="confirm-popover-header">
        <h3 class="confirm-popover-title">{{ title }}</h3>
        <button
          class="confirm-popover-close button icon clean"
          (click)="handleClose()"
          aria-label="Close confirmation"
        >
          <ly-icon icon="close" size="16px"></ly-icon>
        </button>
      </div>

      <div class="confirm-popover-content">
        <p class="confirm-popover-callout-text">
          {{ confirmCalloutContent }}
        </p>
        <p class="confirm-popover-text">{{ content }}</p>
      </div>

      <div class="confirm-popover-actions">
        <button
          *ngIf="confirmHasRejectBtn"
          class="confirm-popover-btn reject-btn button {{
            confirmRejectBtnClasses
          }}"
          (click)="handleReject()"
        >
          {{ confirmRejectBtnLabel }}
        </button>

        <button
          class="confirm-popover-btn confirm-btn button {{ confirmBtnClasses }}"
          (click)="handleConfirm()"
        >
          {{ confirmBtnLabel }}
        </button>
      </div>
    </div>
  `,
  styleUrl: './confirm-popover.component.scss',
})
export class ConfirmPopoverComponent {
  title = '';
  content = '';
  confirmCalloutContent = '';
  confirmBtnLabel = '';
  confirmBtnClasses = '';
  confirmHasRejectBtn = false;
  confirmRejectBtnLabel = '';
  confirmRejectBtnClasses = '';

  close = new EventEmitter();
  confirm = new EventEmitter();
  reject = new EventEmitter();

  handleClose() {
    this.close.emit();
  }

  handleConfirm() {
    this.confirm.emit();
  }

  handleReject() {
    this.reject.emit();
  }
}
